import SecureLS from 'secure-ls';
const ls = new SecureLS({encodingType: 'aes'});
export default ls;